import { render, staticRenderFns } from "./GiftTips.vue?vue&type=template&id=7051d814&scoped=true&"
import script from "./GiftTips.vue?vue&type=script&lang=ts&"
export * from "./GiftTips.vue?vue&type=script&lang=ts&"
import style0 from "./GiftTips.vue?vue&type=style&index=0&id=7051d814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051d814",
  null
  
)

export default component.exports